import { useState, useEffect } from 'react'

const POLL_INTERVAL_MS = 100
const MAX_WAIT_MS = 1000

export const useAlgoliaLastViewedData = enabled => {
  const [state, setState] = useState({ data: null, error: null, loading: true })

  useEffect(() => {
    if (!enabled) return

    let elapsed = 0

    const interval = setInterval(() => {
      const preloadedState = typeof window !== 'undefined' && window.__PRELOADED_STATE_listerFragment__

      if (preloadedState?.byId) {
        clearInterval(interval)
        setState({ data: preloadedState.byId, error: null, loading: false })
        return
      }

      elapsed += POLL_INTERVAL_MS

      if (elapsed >= MAX_WAIT_MS) {
        clearInterval(interval)
        setState({ data: null, error: null, loading: false })
      }
    }, POLL_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [enabled])

  return state
}
